/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rate: NonNullable<unknown> }} Ccsl_Export_Metadata_Frame_RateInputs */

const en_ccsl_export_metadata_frame_rate = /** @type {(inputs: Ccsl_Export_Metadata_Frame_RateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Frame Rate: ${i?.rate}`)
};

const fr_ccsl_export_metadata_frame_rate = /** @type {(inputs: Ccsl_Export_Metadata_Frame_RateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Frequence d'images : ${i?.rate}`)
};

const de_ccsl_export_metadata_frame_rate = /** @type {(inputs: Ccsl_Export_Metadata_Frame_RateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bildrate: ${i?.rate}`)
};

const it_ccsl_export_metadata_frame_rate = /** @type {(inputs: Ccsl_Export_Metadata_Frame_RateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Frequenza fotogrammi: ${i?.rate}`)
};

const ru_ccsl_export_metadata_frame_rate = /** @type {(inputs: Ccsl_Export_Metadata_Frame_RateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Частота кадров: ${i?.rate}`)
};

const es_ccsl_export_metadata_frame_rate = /** @type {(inputs: Ccsl_Export_Metadata_Frame_RateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Velocidad de fotogramas: ${i?.rate}`)
};

const zh_cn2_ccsl_export_metadata_frame_rate = /** @type {(inputs: Ccsl_Export_Metadata_Frame_RateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`帧率：${i?.rate}`)
};

const ja_ccsl_export_metadata_frame_rate = /** @type {(inputs: Ccsl_Export_Metadata_Frame_RateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`フレームレート: ${i?.rate}`)
};

const hi_ccsl_export_metadata_frame_rate = /** @type {(inputs: Ccsl_Export_Metadata_Frame_RateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`फ्रेम दर: ${i?.rate}`)
};

const pt_pt2_ccsl_export_metadata_frame_rate = /** @type {(inputs: Ccsl_Export_Metadata_Frame_RateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Taxa de quadros: ${i?.rate}`)
};

/**
* | output |
* | --- |
* | "Frame Rate: {rate}" |
*
* @param {Ccsl_Export_Metadata_Frame_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_metadata_frame_rate = /** @type {((inputs: Ccsl_Export_Metadata_Frame_RateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Metadata_Frame_RateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_metadata_frame_rate(inputs)
	if (locale === "de") return de_ccsl_export_metadata_frame_rate(inputs)
	if (locale === "it") return it_ccsl_export_metadata_frame_rate(inputs)
	if (locale === "ru") return ru_ccsl_export_metadata_frame_rate(inputs)
	if (locale === "es") return es_ccsl_export_metadata_frame_rate(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_metadata_frame_rate(inputs)
	if (locale === "ja") return ja_ccsl_export_metadata_frame_rate(inputs)
	if (locale === "hi") return hi_ccsl_export_metadata_frame_rate(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_metadata_frame_rate(inputs)
	return en_ccsl_export_metadata_frame_rate(inputs)
});